import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function slugify(s: string): string {
  return s
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");
}

export function getCityNameForSearch(location: string): string {
  const s = (location ?? "").trim();
  const commaIndex = s.indexOf(",");
  return commaIndex > 0 ? s.slice(0, commaIndex).trim() : s;
}

export function getMutationErrorMessage(error: Error, fallback: string): string {
  const ax = error as { response?: { data?: { error?: string } } };
  return ax?.response?.data?.error ?? error?.message ?? fallback;
}

export function formatDisplayName(value: string): string {
  const s = (value ?? "").trim();
  if (!s) return s;
  const withSpaces = s
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .replace(/_/g, " ");
  return withSpaces
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}